module.exports = __webpack_public_path__ + "static/media/dialog_queen_mea_02.0dd76b01.png";